import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.min.css'
import MobileOptimizer from './components/MobileOptimizer.jsx'

import { HelmetProvider } from 'react-helmet-async'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <MobileOptimizer />
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)